import React from "react";
import style from "./style.module.scss";
import Header from "../../../../components/Header";
import LoadingWrapper from "../../../../components/LoadingWrapper";
import ReviewWidget from "../ReviewWidget";
import { ExamListItem } from "../../../../service/exam";

interface ReviewListLayoutProps {
    children: React.ReactNode;
    examInfo: ExamListItem;
}

export default function ReviewListLayout({
    children,
    examInfo
}: ReviewListLayoutProps) {
    return (
        <div>
            <Header />

            <LoadingWrapper isEmpty={false} loading={false}>
                {() => (
                    <div className={style.root}>
                        <div className={style.widget}>
                            <ReviewWidget examInfo={examInfo} />
                        </div>

                        <div className={style.main}>{children}</div>
                    </div>
                )}
            </LoadingWrapper>
        </div>
    );
}
